import { useState } from 'react';

export default function Contact() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !name || !message) {
      alert('모든 항목을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('name', name);
      formData.append('message', message);

      const response = await fetch('https://readdy.ai/api/form/d6ao5rdt1k61917cmu3g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
        setName('');
        setMessage('');
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer id="contact" className="py-32 px-16 bg-[#1A2332]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-5 gap-16">
          {/* Left - Contact Form */}
          <div className="col-span-2 space-y-8">
            <div className="space-y-4">
              <h2 className="text-5xl font-bold text-white leading-tight">
                문의하기<br />지금 바로
              </h2>
              <p className="text-gray-400 text-base">
                맞춤형 인솔에 대해 궁금한 점이 있으신가요? 전문 상담사가 친절하게 답변해드립니다
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
              <div className="space-y-2">
                <label className="text-gray-400 text-sm">이름</label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full bg-transparent border-b-2 border-gray-600 text-white py-3 focus:border-teal-500 outline-none transition-colors"
                  placeholder="이름을 입력하세요"
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="text-gray-400 text-sm">이메일 주소</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-transparent border-b-2 border-gray-600 text-white py-3 focus:border-teal-500 outline-none transition-colors"
                  placeholder="이메일을 입력하세요"
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="text-gray-400 text-sm">문의 내용</label>
                <textarea
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  maxLength={500}
                  className="w-full bg-transparent border-b-2 border-gray-600 text-white py-3 focus:border-teal-500 outline-none transition-colors resize-none"
                  placeholder="문의 내용을 입력하세요 (최대 500자)"
                  rows={3}
                  required
                />
                <p className="text-gray-500 text-xs text-right">{message.length} / 500</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 border-2 border-white text-white rounded-full font-semibold hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '전송 중...' : '상담 신청하기'}
              </button>

              {submitStatus === 'success' && (
                <p className="text-teal-400 text-center">문의가 성공적으로 전송되었습니다!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-400 text-center">전송 중 오류가 발생했습니다. 다시 시도해주세요.</p>
              )}
            </form>
          </div>

          {/* Right - Navigation Links */}
          <div className="col-span-3 grid grid-cols-3 gap-12">
            <div className="space-y-6">
              <h3 className="text-white font-semibold text-lg">제품</h3>
              <ul className="space-y-4">
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">맞춤 인솔</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">스포츠 인솔</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">일상용 인솔</a></li>
              </ul>
            </div>

            <div className="space-y-6">
              <h3 className="text-white font-semibold text-lg">회사</h3>
              <ul className="space-y-4">
                <li><a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">소개</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">팀</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">채용</a></li>
              </ul>
            </div>

            <div className="space-y-6">
              <h3 className="text-white font-semibold text-lg">지원</h3>
              <ul className="space-y-4">
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">FAQ</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">배송</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">반품</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-20 pt-8 border-t border-gray-700 flex justify-between items-center">
          <p className="text-gray-500 text-sm">© 2025 맞춤형 인솔. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
